// App Tracking Transparency — REMOVED.
// Calofay does not track users on iOS (App Privacy: no tracking), so the ATT
// plugin and NSUserTrackingUsageDescription are no longer in the iOS build.
// The same exports are kept as no-ops so callers keep working.
// AppsFlyer always runs in privacy mode on iOS (no advertising ID, no user id).

import { isNativeApp, nativePlatform } from "@/lib/native";

const DECISION = isNativeApp() && nativePlatform() === "ios" ? "disabled" : "unavailable";

export const attDecided = Promise.resolve(DECISION);
export function isATTSupported() { return false; }
export async function getATTStatus() { return "unavailable"; }
export async function requestATT() { return DECISION; }
export function setTrackingDisabled() {}
export function markATTDecided() {}
